module.exports={pagination:{ListCertificates:{input_token:"NextToken",limit_key:"MaxItems",output_token:"NextToken",result_key:"CertificateSummaryList"}}};